namespace Areas.Project.AllAttachment {
    "use strict";

    let runQuery: boolean = false;
    let attachmentType: string;
  
    export function getData(e: any) {
        attachmentType = e.value;
        runQuery = true;
        Areas.Project.Upload.associateUploadWithValue("attachmentType", attachmentType);
        $("#AllAttachmentGrid").dxDataGrid("instance").refresh();
    }

    export function getAttachmentType() {
        return attachmentType;
    } 

    export function canExecuteQuery() {
        return runQuery;
    }
    
}